/**
 * @file main.tsx
 * @description React 18 application bootstrap.
 * Wraps the app with Redux Provider and React Router.
 * StrictMode is enabled in development for detecting side effects.
 */
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import App from './App.js';
import './styles/globals.css';
import './shared/utils/themeUtils.js';

const rootElement = document.getElementById('root');

if (!rootElement) {
  throw new Error(
    '[main.tsx] Root element with id="root" not found. CheckRounded index.html.',
  );
}

createRoot(rootElement).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
